import { FuelButton, FuelSign, FuelTypography } from '@frete.com/fuel-react';
import { FuelFlex, FuelModal } from '@frete.com/fuel-station-react';
import { BenefitsModalProps } from 'open-search/types';
import React, { FC } from 'react';
import * as Styled from './styled';

const InviteDriverBenefits: FC<BenefitsModalProps> = ({ events, states }) => (
  <FuelModal
    isOpen={states.isOpen}
    showCloseButton
    onClose={events.onClose}
    portalName="portal-search-trucker"
    removePortalOnDestroy={false}
    vAlignment="center"
    hAlignment="center"
    width="md"
  >
    <FuelFlex defaultProps={{ flexDirection: 'column', gap: 'km6' }}>
      <FuelTypography size="heading-sm" color="neutral-strong" weight="bold">
        Benefícios disponíveis:
      </FuelTypography>
      <Styled.BenefitsContentWrapper>
        {states.benefits.map((benefit: string) => (
          <FuelFlex defaultProps={{ alignItems: 'center', gap: 'km4' }} key={benefit}>
            <FuelSign icon="one-check" size="medium" color="default" />
            <FuelTypography size="body-sm" color="neutral-default" weight="medium">
              {benefit}
            </FuelTypography>
          </FuelFlex>
        ))}
      </Styled.BenefitsContentWrapper>
      <FuelButton size="medium" variant="whatsapp" fullWidth onClick={events.onWhatsAppButtonClick}>
        {states.whatsAppButtonTextContent}
      </FuelButton>
    </FuelFlex>
  </FuelModal>
);

export default InviteDriverBenefits;
